import axios from 'axios'
import { getApiGatewayUrl, getApiTimeout } from '../config.js'

const axiosInstance = axios.create({
    baseURL: getApiGatewayUrl() || import.meta.env.VITE_API_URL,
    timeout: getApiTimeout(),
    headers: {
        'Content-Type': 'application/json'
    }
})

// Add request interceptor to add auth headers
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token')
        const sessionId = localStorage.getItem('sessionId')
        if (token) {
            config.headers['X-Auth-Token'] = token
        }
        if (sessionId) {
            config.headers['SessionID'] = sessionId
        }

        // The signed token. Without it the request arrives unauthenticated and
        // the server runs it UNRESTRICTED - returning every tenant's rows from
        // the legacy procedures, which have no tenant filter of their own.
        // With it, the server sets the database session tenant and row-level
        // security scopes the query. See services/http.ts for the longer note.
        const accessToken = localStorage.getItem('saas_access_token')
        if (accessToken) {
            config.headers['Authorization'] = `Bearer ${accessToken}`
        }

        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

export default axiosInstance
